import React from 'react';
import PropTypes from 'prop-types';

import css from './wrapper-for-form-element-without-label.css';

const WrapperForFormElementWithoutLabel = ({
  children,
}) => {
  return (
    <div className={css.wrapperForFormElementWithoutLabel}>
      { children }
    </div>
  );
};

WrapperForFormElementWithoutLabel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WrapperForFormElementWithoutLabel;
